import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClinicDTO } from './clinic.dto';

@Injectable({
  providedIn: 'root',
})
export class ClinicApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  getSubDomain(sub: string): Observable<ClinicDTO> {
    return this.http.get<ClinicDTO>(this.apiUrl + `/clinic/sub-domain/${sub}`);
  }
}
